import { combineReducers } from 'redux';

import configReducer from './configReducer';
import authReducer from './authReducer';
import uiReducer from './uiReducer';
import lightboxReducer from './lightboxReducer';
import notificationReducer from './notificationReducer';
import partnerOperationReducer from './partnerOperationReducer';

import timelineReducer from './timelineReducer';
import mailGroupReducer from './mailGroupReducer';
import mailDraftReducer from './mailDraftReducer';
import mailTrashReducer from './mailTrashReducer';
import bestpartnerReducer from './bestpartnerReducer';
import myProfileReducer from './myProfileReducer';
import myProofReducer from './myProofReducer';
import myPhotoReducer from './myPhotoReducer';
import myKeywordReducer from './myKeywordReducer';
import myPostReducer from './myPostReducer';
import myPostGoodUserReducer from './myPostGoodUserReducer';
import myQaQuestionReducer from './myQaQuestionReducer';
import myQaAnswerReducer from './myQaAnswerReducer';
import myPersonalityReducer from './myPersonalityReducer';
import myRequestReducer from './myRequestReducer';
import mySettingReducer from './mySettingReducer';
import paymentTicketSenderReducer from './paymentTicketSenderReducer';
import paymentTicketReceiverReducer from './paymentTicketReceiverReducer';

import communityPostReducer from './communityPostReducer';
import communityQaReducer from './communityQaReducer';
import communityKeywordReducer from './communityKeywordReducer';
import searchReducer from './searchReducer';
import searchCondition from './searchConditionReducer';
import footprintPartnerReducer from './footprintPartnerReducer';
import footprintMyReducer from './footprintMyReducer';
import favoritePartnerReducer from './favoritePartnerReducer';
import favoriteMyReducer from './favoriteMyReducer';
import memoReducer from './memoReducer';
import helpReducer from './helpReducer';
import guideReducer from './guideReducer';
import newsReducer from './newsReducer';
import articlesReducer from './articlesReducer';

const appReducer = combineReducers({
  config: configReducer,
  auth: authReducer,
  ui: uiReducer,
  lightbox: lightboxReducer,
  partnerOperation: partnerOperationReducer,
  notification: notificationReducer,
  timeline: timelineReducer,
  mailGroup: mailGroupReducer,
  mailDraft: mailDraftReducer,
  mailTrash: mailTrashReducer,
  bestpartner: bestpartnerReducer,
  my: combineReducers({
		profile: myProfileReducer,
    proof: myProofReducer,
    photo: myPhotoReducer,
    keyword: myKeywordReducer,
    post: myPostReducer,
    postGoodUser: myPostGoodUserReducer,
    qaQuestion: myQaQuestionReducer,
    qaAnswer: myQaAnswerReducer,
    personality: myPersonalityReducer,
    request: myRequestReducer,
    setting: mySettingReducer,
	}),
  communityPost: communityPostReducer,
  communityQa: communityQaReducer,
  communityKeyword: communityKeywordReducer,
  search: searchReducer,
  searchCondition: searchCondition,
  footprint: combineReducers({
		partner: footprintPartnerReducer,
    my: footprintMyReducer,
	}),
  favorite: combineReducers({
		partner: favoritePartnerReducer,
    my: favoriteMyReducer,
	}),
  memo: memoReducer,
  paymentTicket: combineReducers({
		sender: paymentTicketSenderReducer,
    receiver: paymentTicketReceiverReducer,
	}),
  help: helpReducer,
  guide: guideReducer,
  news: newsReducer,
  articles: articlesReducer,
});

export const rootReducer = (state, action) => {
  if (action.type === "REDUCER_INIT") {
    state = undefined;
  }
  return appReducer(state, action);
};
